export default __webpack_public_path__ + "static/media/reconciliacion.6d3bcc45.png";